(() => {
  if (customElements.get('mareld-restock')) return;
  const endpoint = 'https://sync.mareld.de/mareld-restock.php';
  let statusPromise;
  function status() {
    return statusPromise ||= fetch(`${endpoint}?action=status`, { credentials: 'omit', cache: 'no-store' })
      .then(response => { if (!response.ok) throw new Error('status'); return response.json(); })
      .catch(() => ({ enabled: false }));
  }
  function preview() {
    try {
      if (new URLSearchParams(location.search).get('mareld-restock-test') === '1') sessionStorage.setItem('mareld-restock-test', '1');
      if (new URLSearchParams(location.search).get('mareld-restock-test') === '0') sessionStorage.removeItem('mareld-restock-test');
      return sessionStorage.getItem('mareld-restock-test') === '1';
    } catch { return new URLSearchParams(location.search).get('mareld-restock-test') === '1'; }
  }
  customElements.define('mareld-restock', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-restock-form]');
      this.feedback = this.querySelector('[data-restock-feedback]');
      this.variant = { id: this.dataset.variant, available: this.dataset.available === 'true', title: this.dataset.title };
      this.allowed = false;
      this.installHints();
      this.onSubmit = this.submit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
      if (window.FoxTheme?.pubsub) this.unsubscribe = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data?.sectionId) !== this.dataset.section) return;
        const selected = event.data.variant;
        const serverTitle = event.data.html?.querySelector('mareld-restock')?.dataset.title;
        this.variant = selected ? { ...selected,
          title: selected.title || selected.options?.join(' / ') || serverTitle || '' } : null;
        this.feedback.hidden = true;
        this.update();
        if (this.scrollRequested && !this.hidden) this.scrollToForm();
        this.scrollRequested = false;
      });
      status().then(settings => {
        if (!this.isConnected) return;
        this.allowed = settings.enabled === true && (settings.test_mode !== true || preview());
        this.update();
      });
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.unsubscribe?.();
      this.hintObserver?.disconnect();
      this.picker?.removeEventListener('change', this.onPickerChange);
      this.clearHints();
    }
    update() {
      this.updateHints();
      const soldOut = this.variant?.id && this.variant.available === false;
      this.hidden = !(this.allowed && soldOut);
      this.querySelector('[data-restock-variant]').textContent = this.variant?.title === 'Default Title' ? '' : (this.variant?.title || '');
    }
    installHints() {
      this.picker = document.getElementById(`variant-selects-${this.dataset.section}`);
      if (!this.picker) return;
      this.onPickerChange = event => {
        this.scrollRequested = event.isTrusted;
        this.updateHints();
      };
      this.picker.addEventListener('change', this.onPickerChange);
      this.hintObserver = new MutationObserver(() => this.updateHints());
      this.hintObserver.observe(this.picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    bell() {
      const span = document.createElement('span');
      span.className = 'mareld-restock-bell';
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" focusable="false" aria-hidden="true"><path fill="currentColor" d="M12 2a2 2 0 0 0-2 2v.35A6 6 0 0 0 6 10v4l-2 3v1h16v-1l-2-3v-4a6 6 0 0 0-4-5.65V4a2 2 0 0 0-2-2Zm-3 18a3 3 0 0 0 6 0Z"/></svg>';
      return span;
    }
    clearHints() {
      if (!this.picker) return;
      this.picker.querySelectorAll('.mareld-restock-option').forEach(label => {
        label.classList.remove('mareld-restock-option');
        label.querySelector('.mareld-restock-bell')?.remove();
        label.querySelector('[data-restock-option-help]')?.remove();
      });
      this.picker.querySelectorAll('[data-restock-hint]').forEach(hint => hint.remove());
    }
    updateHints() {
      if (!this.picker) return;
      let variants;
      const cache = this.picker.querySelector('[data-variants-cache]');
      try { variants = JSON.parse(cache?.textContent || '[]'); } catch { variants = []; }
      const groups = Array.from(this.picker.querySelectorAll(':scope > .product-form__input'));
      // A partial cache cannot distinguish missing combinations from sold-out variants.
      if (!this.allowed || cache?.dataset.complete !== 'true' || !variants.length || groups.length !== variants[0].options?.length) {
        this.clearHints(); return;
      }
      const selected = groups.map(group => group.querySelector('input:checked, select option:checked')?.value);
      groups.forEach((group, index) => {
        let hasSoldOut = false;
        group.querySelectorAll('input[type="radio"]').forEach(input => {
          const label = Array.from(group.querySelectorAll('label[for]')).find(item => item.htmlFor === input.id);
          if (!label) return;
          const elsewhere = input.dataset.productUrl && input.dataset.productUrl !== this.picker.dataset.url;
          const matches = variants.filter(variant => variant.options.every((value, position) =>
            position === index ? value === input.value : position < index ? value === selected[position] : true));
          const soldOut = !elsewhere && matches.length > 0 && matches.every(variant => variant.available === false);
          hasSoldOut ||= soldOut;
          if (label.classList.contains('mareld-restock-option') !== soldOut) label.classList.toggle('mareld-restock-option', soldOut);
          if (soldOut && !label.querySelector('.mareld-restock-bell')) {
            label.appendChild(this.bell());
            const help = document.createElement('span');
            help.className = 'visually-hidden'; help.dataset.restockOptionHelp = '';
            help.textContent = ' – auswählen und bei Verfügbarkeit benachrichtigen lassen';
            label.appendChild(help);
          } else if (!soldOut) {
            label.querySelector('.mareld-restock-bell')?.remove();
            label.querySelector('[data-restock-option-help]')?.remove();
          }
        });
        let hint = group.querySelector('[data-restock-hint]');
        if (hasSoldOut && !hint) {
          hint = document.createElement('p'); hint.dataset.restockHint = '';
          hint.className = 'mareld-restock-hint'; hint.appendChild(this.bell());
          const text = document.createElement('span');
          text.textContent = 'Deine Auswahl ist ausverkauft? Wähle sie aus und lass dich benachrichtigen.';
          hint.appendChild(text); group.appendChild(hint);
        } else if (!hasSoldOut) hint?.remove();
      });
    }
    scrollToForm() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      requestAnimationFrame(() => {
        if (this.hidden || !this.isConnected) return;
        this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity() || !this.allowed || this.variant?.available !== false) return;
      const chosenVariant = String(this.variant.id);
      const button = this.form.querySelector('button');
      this.busy = true; button.disabled = true;
      this.feedback.hidden = false; this.feedback.dataset.error = 'false';
      this.feedback.textContent = 'Wir senden dir die Bestätigungsmail …';
      const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 60000);
      try {
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: this.form.elements.email.value.trim(), variant: chosenVariant,
            consent: this.form.elements.consent.checked, website: this.form.elements.website.value })
        });
        const result = await response.json();
        if (!response.ok || result.ok !== true) throw new Error(result.message || 'Bitte versuche es später erneut.');
        if (String(this.variant?.id) === chosenVariant) {
          this.feedback.textContent = result.message;
          this.form.reset();
        }
      } catch (error) {
        if (String(this.variant?.id) === chosenVariant) {
          this.feedback.dataset.error = 'true';
          this.feedback.textContent = error.name === 'AbortError' || error instanceof TypeError
            ? 'Die Anfrage konnte nicht abgeschlossen werden. Bitte prüfe dein Postfach und versuche es später erneut.' : error.message;
        }
      } finally { clearTimeout(timeout); this.busy = false; button.disabled = false; }
    }
  });
})();
